/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./answer.css";
import "./answermobileview.css";
import "./individualquestion_mobileview.css";
import { Post } from "../../../services/axiosCall";
import apis from "../../../services/Apis";
import Alert from "../../common/alert";
// import {
//   FeedbackStatus,
//   fetchTraineeTestQuestionsResult,
// } from "../../../actions/traineeAction";
import {
  setHasGivenFeedback,
  updateTraineeTestQuestionsResult,
} from "../../../reducers/trainee";
import QuestionResult from "./QuestionResult";
import { useSearchParams } from "react-router-dom";
import { retriveToken } from "../../../services/AuthServices";

const Answer = () => {
  const dispatch = useDispatch();
  const trainee = useSelector((state) => state.trainee);
  // console.log(trainee);
  

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [role, setRole] = useState();
  const [totalScore, setTotalScore] = useState(null);
  const [visible, setVisible] = useState(false);
  const [testName, setTestName] = useState(null);
  const [totalMarks, setTotalMarks] = useState();

  const [searchParams] = useSearchParams();
  const isCorrect = searchParams.get("isCorrect") === "true";
  const traineeid = searchParams.get("traineeid");
  const testid = searchParams.get("testid");

  const [reFetch, setReFetch] = useState(false);

  useEffect(() => {
    const token = retriveToken();

    const fetchData = async () => {
      if (!traineeid || !testid) return;

      setLoading(true);

      try {
        const commonResultData = {
          userid: traineeid,
          testid: testid,
        };

        const commonQuestionData = {
          id: testid,
        };

        const resultPayload = isCorrect
          ? { ...commonResultData, isCorrect }
          : commonResultData;

        const questionPayload = isCorrect
          ? { ...commonQuestionData, isCorrect, userId: traineeid }
          : commonQuestionData;

        const [resultRes, questionRes, feedbackRes] = await Promise.all([
          Post({
            url: apis.FETCH_OWN_RESULT,
            data: resultPayload,
            params: { Token: token },
          }),
          Post({
            url: apis.FETCH_TRAINEE_TEST_QUESTION,
            data: questionPayload,
          }),
          Post({
            url: apis.FEEDBACK_STATUS_CHECK,
            data: commonResultData,
          }),
        ]);

        setLoading(false);

        const resultSuccess = resultRes.data.success;
        const questionSuccess = questionRes.data.success;

        if (resultSuccess && questionSuccess) {
          const questions = questionRes.data.data;
          updateTraineeTestQuestionsResult(questions);

          const mergedResult = resultRes.data.result.result.map((item, i) => ({
            ...item,
            ...questions[i],
          }));
            // console.log("Merged Result",mergedResult);
          

          setData(mergedResult);
          setTotalScore(resultRes.data.result.score);
          setRole(resultRes.data.role);
          setTestName(resultRes.data.title);
          setTotalMarks(resultRes.data.totalMarks);

          if (feedbackRes.data.success) {
            dispatch(setHasGivenFeedback(feedbackRes.data.status));
          }
        } else {
          Alert(
            "error",
            "Error!",
            `${!resultSuccess ? resultRes.data.message : ""} ${
              !questionSuccess ? questionRes.data.message : ""
            }`
          );
        }
      } catch (error) {
        setLoading(false);
        const message =
          error?.response?.data?.message || error.message || "Unknown error";
        // console.error("Error fetching test data:", message);
        // Optionally show error alert
        // Alert("error", "Error!", message);
      }
    };

    fetchData();
  }, [trainee.traineeid, trainee.testid, reFetch]);

  const onOpen = () => setVisible(true);

  return (
    <div className="exam-dashboard-wrapper-new">
      <QuestionResult
        reFetch={reFetch}
        setReFetch={setReFetch}
        role={role}
        data={data}
        isCorrect={isCorrect}
        triggerSidebar={onOpen}
        totalScore={totalScore}
        testName={testName}
        totalMarks={totalMarks}
      />
    </div>
  );
};

export default Answer;
